import { get, post } from '@/tools/http';

const service = 'profile';

export default {
    namespaced: true,
    state: {
        surveys: [],
        surveysCount: null,
    },
    getters: {
        getSurveys: state => state.surveys,
        getSurveysCount: state => state.surveysCount,
    },
    mutations: {
        setSurveys: (state, data) => state.surveys = data,
        setSurveysCount: (state, data) => state.surveysCount = data,
    },
    actions: {
        fetchSurveys: async (ctx) => {
            let groupId = ctx.rootState.mentoring.groupId;
            const query = `limit=9000&offset=0&filter[groupId]=${groupId}`;

            const response = await get(service, `mentoringSurvey?${query}`);

            let preparedList = await Promise.all(response.items.map(async item => {

                if (new Date() > new Date(item.dateEnd)) {
                    item.status = 'aborted';
                    return item;
                } else {
                    //ToDo: get status from examination
                    let result = await get('examination', `sessions/survey/${item.foreignId}`);

                    item.status = result.items.length ? 'completed' : 'new';
                    return item;
                }
            }));
            
            ctx.commit('setSurveys', preparedList);
            ctx.commit('setSurveysCount', response.total);

            return preparedList;
        },
    },
};